'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('./_index.scss.js');

var CLASSNAME = 'varta-divider';
/**
 * simple horizontal divider
 * @returns 
 */

function Divider() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: CLASSNAME
  });
}

module.exports = Divider;
